import { GRID_TREE_DATA_GROUPING_FIELD } from '@mui/x-data-grid-premium';

export enum MUIDataGridColumn {
  Actions = 'actions',
  City = 'city',
  Dealers = 'dealers',
  GroupName = 'group-name',
  Site = 'site',
  Email = 'email',
  Name = 'name',
  Permissions = 'permissions',
  Phone = 'phone',
  State = 'state',
  Status = 'status',
  Configurators = 'configurators',
  Pricing = 'pricing',
  DealerNetwork = 'dealer-network',
  Template = 'template',
  SalesTools = 'sales-tools',
  ProServicesBranch = 'pro-services-branch',
  VendorKey = 'vendor-key',
  Key = 'key',
  Type = 'type',
  Zip = 'zip',
}

export enum MUIDataGrid {
  AllUsers = 'allUsers',
  Configurators = 'configurators',
  Dealers = 'dealers',
  Users = 'users',
  Groups = 'groups',
}

export enum MUIDataGridKey {
  Default = 'MUIDataGrid',
  Dealers = 'MUIDataGridDealers',
  Users = 'MUIDataGridUsers',
  Payments = 'MUIDataGridPayments',
  Orders = 'MUIDataGridOrders',
  Leads = 'MUIDataGridLeads',
}

export const DEFAULT_GAP = 24;

export const muiDataGridColumnWidths: {
  [column: string]: { flex?: number; minWidth?: number; width?: number; maxWidth?: number };
} = {
  [MUIDataGridColumn.Actions]: { width: 50, minWidth: 50, maxWidth: 50 },
  [MUIDataGridColumn.City]: { width: 200 },
  [MUIDataGridColumn.Dealers]: { width: 300 },
  [MUIDataGridColumn.Site]: { width: 78 },
  [MUIDataGridColumn.Email]: { width: 300 },
  [MUIDataGridColumn.Name]: { width: 250 },
  [MUIDataGridColumn.Permissions]: { width: 200 },
  [MUIDataGridColumn.Phone]: { width: 200 },
  [MUIDataGridColumn.State]: { width: 250 },
  [MUIDataGridColumn.Status]: { width: 150 },
  [GRID_TREE_DATA_GROUPING_FIELD]: { width: 50, minWidth: 50, maxWidth: 50 },
  [MUIDataGridColumn.GroupName]: { minWidth: 300, flex: 1 },
  [MUIDataGridColumn.VendorKey]: { width: 200 },
  [MUIDataGridColumn.Key]: { width: 125 },
  [MUIDataGridColumn.Type]: { width: 125 },
  [MUIDataGridColumn.Pricing]: { width: 125 },
  [MUIDataGridColumn.DealerNetwork]: { width: 125 },
  [MUIDataGridColumn.Template]: { width: 125 },
  [MUIDataGridColumn.SalesTools]: { width: 125 },
  [MUIDataGridColumn.ProServicesBranch]: { width: 125 },
};

export const dealersColumns = [
  MUIDataGridColumn.Name,
  MUIDataGridColumn.City,
  MUIDataGridColumn.State,
  MUIDataGridColumn.Zip,
  MUIDataGridColumn.Phone,
  MUIDataGridColumn.Email,
  MUIDataGridColumn.Site,
  MUIDataGridColumn.Actions,
];

export const usersColumns = [
  MUIDataGridColumn.Name,
  MUIDataGridColumn.Email,
  MUIDataGridColumn.Phone,
  MUIDataGridColumn.Configurators,
  MUIDataGridColumn.Dealers,
  MUIDataGridColumn.Permissions,
  MUIDataGridColumn.Status,
  MUIDataGridColumn.Actions,
];

export const configuratorsColumns = [
  MUIDataGridColumn.VendorKey,
  MUIDataGridColumn.Key,
  MUIDataGridColumn.Name,
  MUIDataGridColumn.Type,
  MUIDataGridColumn.Pricing,
  MUIDataGridColumn.DealerNetwork,
  MUIDataGridColumn.Template,
  MUIDataGridColumn.SalesTools,
  MUIDataGridColumn.ProServicesBranch,
  MUIDataGridColumn.Actions,
];
